export default __webpack_public_path__ + "assets/card-logo-diners-club-component.acb567db.svg";